import moment from 'moment';
/**
 * Take an array of time off requests and return an array of time off requests.
 * If a request spans multiple days, it will be split into single day requests
 * (ex: 9/16 - 9/19) will be split into 4 single day requests where the only difference between them are the start and end dates
 * @param {Object[]} requests
 * @returns {Object[]}
 */
export const splitTimeOffRangeRequests = requests => {
  let timeOffRequests = [];

  requests.forEach(req => {
    const { start, end } = req;
    const isSameDate = moment(end).isSame(moment(start), 'day');

    if (!isSameDate) {
      for (let m = moment(start); m.isBefore(moment(end)); m.add(1, 'day')) {
        // ensure the end date is set to 5pm
        let newEnd = m.clone().startOf('day').hour(17).minute(0).second(0).millisecond(0);

        // push existing details with updated start and end times
        timeOffRequests.push({
          ...req,
          start: m.toISOString(),
          end: newEnd.toISOString()
        });
      }
    } else {
      timeOffRequests.push(req);
    }
  });

  return timeOffRequests;
};

/**
 * Get number of working days between two dates
 *
 * @param {Date} start - start date
 * @param {Date} end - end date
 * @returns {Number}
 */
export const numberOfWorkingDays = (start, end) => {
  let workDays = 0;
  let currentDate = moment(start);
  let endDate = moment(end);

  while (currentDate <= endDate) {
    const day = currentDate.day();

    // skip weekends
    if (day !== 0 && day !== 6) {
      workDays += 1;
    }

    currentDate = currentDate.add(1, 'day');
  }

  return workDays;
};
